import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

// 公共自定义字体
import '@/assets/text/text.css'

import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'

const app = createApp(App);
 
app.use(router);
app.use(ElementPlus);
 
app.mount('#app');